import React from "react"
import { IScene } from "@layerhub-io/types"
import { Block } from "baseui/block"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import useDesignEditorContext from "~/hooks/useDesignEditorContext"
import useOnClickOutside from "~/hooks/useOnClickOutside"
import Cookies from 'js-cookie'

const isPersonalizedHardCover = () => {
  const sku = (Cookies.get('photobookSku') || "").toUpperCase()
  const coverFinish = (Cookies.get('cover_finish') || "").toLowerCase()
  return sku.includes("PH") || coverFinish.includes("personalized") || coverFinish.includes("personalised")
}

interface Props {
  isCurrentScene: boolean
  scene: IScene
  preview: string
  index: number
  totalScenes: number
  changePage: (p: IScene) => void
}

export default function ({ isCurrentScene, scene, preview, index, totalScenes, changePage }: Props) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: scene.id })
  const sceneRef = React.useRef<HTMLDivElement>(null)
  const { setContextMenuTimelineRequest } = useDesignEditorContext()

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "pointer",
  }

  React.useEffect(() => {
    const timeLineItemDiv = sceneRef.current
    const handleContextMenu = (event: MouseEvent) => {
      event.preventDefault()
      setContextMenuTimelineRequest({
        id: scene.id,
        left: event.pageX,
        top: event.pageY,
        visible: true,
      })
    }
    if (timeLineItemDiv) {
      timeLineItemDiv.addEventListener("contextmenu", handleContextMenu)
    }
    return () => {
      if (timeLineItemDiv) {
        timeLineItemDiv.removeEventListener("contextmenu", handleContextMenu)
      }
    }
  }, [sceneRef, scene])

  // Determine the label for this page
  const getPageLabel = () => {
    const hasWraparoundCover = isPersonalizedHardCover()

    if (hasWraparoundCover && index === 0) return "Cover"

    return hasWraparoundCover ? `${index}` : `${index + 1}`
  }

  const isCover = isPersonalizedHardCover() && index === 0

  return (
    <Block
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      $style={{
        backgroundColor: isCurrentScene ? "rgb(243,244,246)" : "#ffffff",
        padding: "1rem 0.5rem",
        ...style,
      }}
    >
      <Block
        ref={sceneRef}
        onClick={() => changePage(scene)}
        $style={{
          cursor: "pointer",
          position: "relative",
          border: isCurrentScene ? "2px solid #7158e2" : "2px solid rgba(0,0,0,.15)",
        }}
      >
        {preview ? (
          <img style={{ maxWidth: "90px", maxHeight: "80px", display: "flex" }} src={preview} />
        ) : (
          <div style={{
            width: "90px",
            height: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f3f4f6",
            color: "#9ca3af",
            fontSize: "10px"
          }}>
            Loading...
          </div>
        )}
        <Block
          $style={{
            position: "absolute",
            bottom: "4px",
            right: "4px",
            background: "rgba(0,0,0,0.4)",
            color: "#fff",
            fontSize: isCover ? "8px" : "10px",
            borderRadius: "2px",
            height: "16px",
            width: isCover ? "auto" : "16px",
            padding: isCover ? "0 4px" : "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {getPageLabel()}
        </Block>
      </Block>
    </Block>
  )
}
